import { FormioUtils } from 'angular-formio';

export function getAllComponents(components: any): any {
  return Object.values(FormioUtils.flattenComponents(components, true));
}

export function getFormComponentsFlatArray(components: any) {
  const allComponents = getAllComponents(components);
  const tempAllComponents = allComponents;
  let filteredAddressComponents = [];
  let formComponents = [];

  allComponents.map((component) => {
    if (component.componentType === 'customaddress') {
      // Street
      const street = tempAllComponents.filter((addressComponent) => {
        return (
          filteredAddressComponents.indexOf(addressComponent?.key) === -1 &&
          addressComponent.componentType &&
          addressComponent.componentType.indexOf('customaddress.street') !== -1
        );
      })[0];
      filteredAddressComponents.push(street?.key);
      formComponents.push({
        type: component.componentType || component.type,
        key: street?.key,
        title: `${component.title || component.label} (Street)`,
      });

      // Address line 2
      const address2 = tempAllComponents.filter((addressComponent) => {
        return (
          filteredAddressComponents.indexOf(addressComponent?.key) === -1 &&
          addressComponent.componentType &&
          addressComponent.componentType.indexOf('customaddress.address2') !==
            -1
        );
      })[0];
      filteredAddressComponents.push(address2?.key);
      formComponents.push({
        type: component.componentType || component.type,
        key: address2?.key,
        title: `${component.title || component.label} (Address Line 2)`,
      });

      // City
      const city = tempAllComponents.filter((addressComponent) => {
        return (
          filteredAddressComponents.indexOf(addressComponent?.key) === -1 &&
          addressComponent.componentType &&
          addressComponent.componentType.indexOf('customaddress.city') !== -1
        );
      })[0];
      filteredAddressComponents.push(city?.key);
      formComponents.push({
        type: component.componentType || component.type,
        key: city?.key,
        title: `${component.title || component.label} (City)`,
      });

      // State
      const state = tempAllComponents.filter((addressComponent) => {
        return (
          filteredAddressComponents.indexOf(addressComponent?.key) === -1 &&
          addressComponent.componentType &&
          addressComponent.componentType.indexOf('customaddress.state') !== -1
        );
      })[0];

      // State 1
      const state1 = tempAllComponents.filter((addressComponent) => {
        return (
          filteredAddressComponents.indexOf(addressComponent?.key) === -1 &&
          addressComponent.componentType &&
          addressComponent.componentType.indexOf('customaddress.state1') !== -1
        );
      })[1];

      if (state) {
        filteredAddressComponents.push(state?.key);
        formComponents.push({
          type: component.componentType || component.type,
          key: state?.key,
          title: `${component.title || component.label} (US State)`,
        });
      }

      if (state1) {
        filteredAddressComponents.push(state1?.key);
        formComponents.push({
          type: component.componentType || component.type,
          key: state1?.key,
          title: `${component.title || component.label} (State)`,
        });
      }

      // Postcode
      const postcode = tempAllComponents.filter((addressComponent) => {
        return (
          filteredAddressComponents.indexOf(addressComponent?.key) === -1 &&
          addressComponent.componentType &&
          addressComponent.componentType.indexOf('customaddress.postcode') !==
            -1
        );
      })[0];

      // Postcode 1
      const postcode1 = tempAllComponents.filter((addressComponent) => {
        return (
          filteredAddressComponents.indexOf(addressComponent?.key) === -1 &&
          addressComponent.componentType &&
          addressComponent.componentType.indexOf('customaddress.postcode1') !==
            -1
        );
      })[1];

      if (postcode) {
        filteredAddressComponents.push(postcode?.key);
        formComponents.push({
          type: component.componentType || component.type,
          key: postcode?.key,
          title: `${component.title || component.label} (Postcode)`,
        });
      }

      if (postcode1) {
        filteredAddressComponents.push(postcode1?.key);
        formComponents.push({
          type: component.componentType || component.type,
          key: postcode1?.key,
          title: `${component.title || component.label} (Non-US Postcode)`,
        });
      }

      // Country
      const countries = tempAllComponents.filter((addressComponent) => {
        return (
          filteredAddressComponents.indexOf(addressComponent?.key) === -1 &&
          addressComponent.componentType &&
          addressComponent.componentType.indexOf('customaddress.countries') !==
            -1
        );
      })[0];
      filteredAddressComponents.push(countries?.key);
      formComponents.push({
        type: component.componentType || component.type,
        key: countries?.key,
        title: `${component.title || component.label} (Country)`,
      });
    } else if (component.type === 'subscriptionPlans') {
      formComponents.push({
        type: component.componentType || component.type,
        key: 'subscription.PlanCode',
        title: 'Subscription (Plan Code)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'subscription.PlanName',
        title: 'Subscription (Plan Name)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'subscription.PlanPrice',
        title: 'Subscription (Plan Price)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'heartlandpayment.amount',
        title: 'Payment Form (Total)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'heartlandpayment.paymentType',
        title: 'Payment Form (Payment Type)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'heartlandpayment.firstName',
        title: 'Payment Form (First Name)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'heartlandpayment.lastName',
        title: 'Payment Form (Last Name)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'heartlandpayment.email',
        title: 'Payment Form (Email Address)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'heartlandpayment.phone',
        title: 'Payment Form (Contact Number)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'heartlandpayment.saveCard',
        title: 'Payment Form (Save Card / Create Account)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: 'subscription.PlanDescription',
        title: 'Subscription (Description)',
      });
    } else if (component.type === 'heartlandpayment') {
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.amount`,
        title: 'Payment Form (Total)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.paymentType`,
        title: 'Payment Form (Payment Type)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.firstName`,
        title: 'Payment Form (First Name)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.lastName`,
        title: 'Payment Form (Last Name)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.email`,
        title: 'Payment Form (Email Address)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.phone`,
        title: 'Payment Form (Contact Number)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.saveCard`,
        title: 'Payment Form (Save Card / Create Account)',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `transaction.id`,
        title: 'Transaction ID',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `transaction.date`,
        title: 'Transaction Date',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `transaction.paymentMethod`,
        title: 'Transaction Method',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `transaction.processor`,
        title: 'Transaction Processor',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `transaction.amount`,
        title: 'Transaction Amount',
      });
    } else if (component.type === 'termscondition') {
      formComponents.push({
        type: component.componentType || component.type,
        key: component?.key,
        title: 'Terms and Condition',
      });
    } else if (component.type === 'productfield') {
      const productTitle = component.data && component.data.label;
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.label`,
        title: 'Product Select Title',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.amount`,
        title: `${productTitle} total`,
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.selectedProducts`,
        title: `Selected ${productTitle}`,
      });
    } else if (component.type === 'singleproduct') {
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.productName`,
        title: 'Product Name',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.productPrice`,
        title: 'Price',
      });
      formComponents.push({
        type: component.componentType || component.type,
        key: `${component?.key}.productQuantity`,
        title: 'Quantity',
      });
    } else {
      if (filteredAddressComponents.indexOf(component?.key) === -1) {
        const componentKey = component?.key;
        const componentValue =
          component.title ||
          component.label ||
          component?.customOptions?.product_name;
        formComponents.push({
          type: component.componentType || component.type,
          key: [componentKey],
          title: componentValue,
        });
      }
    }
  });

  return formComponents;
}
